import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBag2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconBag2"><Path d="M5.75 20.25H18.25C19.9069 20.25 21.25 18.9069 21.25 17.25V10.75C21.25 9.09315 19.9069 7.75 18.25 7.75H5.75C4.09315 7.75 2.75 9.09315 2.75 10.75V17.25C2.75 18.9069 4.09315 20.25 5.75 20.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><Path d="M8.00391 20.25V6.75C8.00391 5.09315 9.34705 3.75 11.0039 3.75H13.0039C14.6608 3.75 16.0039 5.09315 16.0039 6.75V20.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
});

export default IconBag2;
